import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_dgjbc7hwxp: FaireCollectionEntity = {
  token: "pbc_dgjbc7hwxp",
  type: "collection",
  name: "baby",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ae9290e5c1c0fb985eaa956738ec76c131c3089954b29250ded19ab96f0c44fb.jpeg",
  itemCount: 19,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.207Z",
    importedBy: "entity-db-import-collections",
  },
};
